<template>
  <section>
    <!-- form-geral -->
    <form @submit.prevent="saveMarca">
      <div class="card card_border">
        <div class="cards__heading">
          <h3>Dados Gerais</h3>
        </div>
        <div class="card-body">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="inputEmail4" class="input__label">descricao</label>
              <input
                type="text"
                class="form-control input-style"
                id="inputEmail4"
                placeholder="descricao"
                name="descricao" v-model="form.descricao"
              />
              
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="inputEmail4" class="input__label">imagem</label>
              <image-marca-upload
                v-model="form.imagem"
              />
              
            </div>
          </div>
        </div>
        <div class="card-footer">

          <button type="submit" class="btn btn-primary btn-style">
            Salvar
          </button>
          
          <button class="btn btn-link"
            @click="()=>$router.push({ name: `${currentMeta.base}.search` })">
            Voltar
          </button>

        </div>
      </div>
    </form>
    <!-- /form-geral -->
  </section>
</template>

<script>

import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";

import useCommon from "@/common";
import useMarca from '@/composables/Marca';

export default {
  
  setup() {
    
    const { openToast } = useCommon();
    const { status, message, error, marca, storeMarca } = useMarca();
    const router = useRouter();
    const currentMeta = router.currentRoute.value.meta;

    const showMessages = () => {
      if(status.value){
        openToast(message.value, 'success');
      }else{
        openToast(error.value, 'error');
      }
    };

    //
    const form = reactive({
      'descricao': '',
      'imagem': '',
    });
    const saveMarca = async () => {
      await storeMarca({...form});
      showMessages();
      if(status){
        await router.push({name:'app.marca.add'});
      }
    }

    onMounted(function(){
      // getdMarca(props.id);
    });

    return {
      form,
      marca,
      saveMarca,
      currentMeta
    };
  },
};
</script>
